module.exports = __webpack_public_path__ + "img/avatar7.725a5fb1.png";